import {
  SET_UNAUTHENTICATED,
  MEMBER_LIST,
  LOADING_USER,
  SET_USER_ACCESS,
  NEW_MEMBER_DATA,
  LOADER_CHECK,
  MEMBER_LIST_EDIT,
  CITY_FILTER_DATA,
  CITY_FILTER_DATA1,
  BUILDING_FILTER_DATA,
  BUILDING_FILTER_DATA1,
  EXPORT_FILE,
  LIST_UPDATE,
  SET_EDIT_USER_LIST,
  BUILK_FILE_UPLOAD,
  BUILDING_SPOC_DATA,
  LOADING_UI,
} from '../type';

const initialState = {
  userList: [],
  latestList: {},
  NewMemberData: [],
  loader: true,
  activeEditData: [],
  CityData: [],
  BuildingData: [],
  CityData1: [],
  BuildingData1: [],
  AcitvmemberListAdd: [],
  AcitvmemberListEdit: [],
  exportData: [],
  builkfiledata: [],
  userGrant: [],
  BuildingSPOCData: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_UNAUTHENTICATED:
      return initialState;
    case MEMBER_LIST:
      return {
        ...state,
        userList: action.payload,
        latestList: action.payload,
        loader: false,
      };

    case SET_USER_ACCESS:
      return {
        ...state,
        userGrant: action.payload,
        loader: false,
      };
    case EXPORT_FILE:
      return {
        ...state,
        exportData: action.payload,
        loader: false,
      };

    case BUILK_FILE_UPLOAD:
      return {
        ...state,
        builkfiledata: action.payload,
        loader: false,
      };

    case LIST_UPDATE:
      return {
        ...state,
        AcitvmemberListAdd: action.payload,
        loader: false,
      };
    case SET_EDIT_USER_LIST:
      return {
        ...state,
        AcitvmemberListEdit: action.payload,
        loader: false,
      };
    case MEMBER_LIST_EDIT:
      return {
        ...state,
        activeEditData: action.payload,
        loader: false,
      };
    case NEW_MEMBER_DATA:
      return {
        ...state,
        NewMemberData: action.payload,
        loader: false,
      };
    case LOADING_UI:
      return {
        ...state,
        loader: true,
      };
    case LOADER_CHECK:
      return {
        ...state,
        loader: false,
      };
    case CITY_FILTER_DATA:
      return {
        ...state,
        CityData: action.payload,
        loader: false,
      };
    case CITY_FILTER_DATA1:
      return {
        ...state,
        CityData1: action.payload,
        loader: false,
      };
    case BUILDING_FILTER_DATA:
      return {
        ...state,
        BuildingData: action.payload,
        loader: false,
      };
    case BUILDING_FILTER_DATA1:
      return {
        ...state,
        BuildingData1: action.payload,
        loader: false,
      };
    case BUILDING_SPOC_DATA:
      return {
        ...state,
        BuildingSPOCData: action.payload,
        loader: false,
      };
    default:
      return state;
  }
}
